module.exports = __webpack_public_path__ + "img/logo_uniovi_pie.f84b7278.png";